import * as ReactDOM from "react-dom/client";
import {
  InterstateThemeProvider,
  interstateThemeRegistry
} from "@dealer-center/core-components";
import { GlobalStyle, StyledApp } from "./app/Styles";

import App from "./app/App";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const queryClient = new QueryClient();
root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <InterstateThemeProvider
        applicationName="ddc"
        scopeName="ddc"
        themeName="Interstate"
        themeRegistries={[interstateThemeRegistry]}
      >
        <GlobalStyle />
        <StyledApp data-testid="cc-internal-landing-ui">
          <App />
        </StyledApp>
      </InterstateThemeProvider>
    </QueryClientProvider>
  </StrictMode>
);
